export const brandSelectorConfig = [
  {
    name: 'placeholderBrand',
    category: 'Locales',
    isLocalizable: true,
    default: 'Select brand',
  },
  {
    name: 'placeholderSearchBrand',
    category: 'Locales',
    isLocalizable: true,
    default: 'Search brand...',
  },
  {
    name: 'isMultiselect:switch',
    category: 'Brands',
  },
];
